import React, { FC, ReactEventHandler } from 'react';

import categoryIcon from 'uikit/Icons/Categories';
import { DrawerLink } from 'uikit/Nav';
import routes from 'utils/routeTranslator';

import './L2CategoryNavItem.scss';

type Props = {
  onClick?: ReactEventHandler<HTMLAnchorElement>;
  category: {
    slug: string;
    city?: string;
    name: string;
  };
  highlighted?: boolean;
};

const L2CategoriesNavItem: FC<Props> = (props) => {
  const { category, onClick, highlighted, ...rest } = props;
  const { slug, city, name } = category;

  return (
    <div className="l2CategoryNavItem">
      {/* @ts-expect-error type mismatch */}
      <DrawerLink url={routes.get('front::categories.type', { slug, city })} onClick={onClick} {...rest}>
        <span className="l2CategoryNavItem__icon">{categoryIcon(slug)}</span>
        <span className={highlighted ? 'l2CategoryNavItem__label_highlighted' : ''}>{name}</span>
      </DrawerLink>
    </div>
  );
};

export default L2CategoriesNavItem;
